import { useState, useCallback } from "react";
import { useAuthenticatedFetchWithWorkspace } from "../../Keycloak/useAuthenticatedFetchWithWorkspace";

export interface TransactionItem {
    TYPEACHAT?: string;
    TRANSACTIONDATE?: string;
    REFERENCE?: string;
    EVENEMENT?: string;
    LIBELLE?: string;
    TTC?: string;
    REMISE?: string;
    QUANTITE?: string;
    [key: string]: unknown;
}

export interface TransactionOffer {
    NUMOPERATION?: string;
    SENTDATE?: string;
    OPERATIONNAME?: string;
    OFFERDESCRIPTION?: string;
    CANAL?: string;
    STARTDATE?: string;
    ENDDATE?: string;
    [key: string]: unknown;
}

export interface TransactionDetails {
    transaction_items: TransactionItem[];
    transaction_offers: TransactionOffer[];
}

const useGetTransactionDetails = () => {
    const { authFetch, isReady, workspaceId } = useAuthenticatedFetchWithWorkspace();
    const [details, setDetails] = useState<TransactionDetails | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");

    const getTransactionDetails = useCallback(
        async (personId: string | number, transactionId: string | number): Promise<void> => {
            if (!isReady || !workspaceId) return;
            setIsLoading(true);
            setError("");
            try {
                const params = new URLSearchParams({
                    person_id: String(personId),
                    transaction_id: String(transactionId),
                    workspace: workspaceId,
                });
                const result: unknown = await authFetch(
                    `/getDetailsTransactionPerson?${params.toString()}`,
                    { method: "GET" }
                );
                if (result && typeof result === "object") {
                    const r = result as Record<string, unknown>;
                    setDetails({
                        transaction_items: (r.transaction_items as TransactionItem[]) ?? [],
                        transaction_offers: (r.transaction_offers as TransactionOffer[]) ?? [],
                    });
                } else {
                    setDetails(null);
                }
            } catch (err: unknown) {
                if (err instanceof Error) setError(err.message);
                else setError("An unknown error occurred");
            } finally {
                setIsLoading(false);
            }
        },
        [authFetch, isReady, workspaceId]
    );

    const reset = useCallback(() => {
        setDetails(null);
        setError("");
    }, []);

    return { details, isLoading, error, getTransactionDetails, reset };
};

export default useGetTransactionDetails;
